import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  viewBox: "0 0 50 44.644",
  height: "44.644",
  width: "50",
  fill: "#1aa",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M8.34 44.645h33.32V25.172L25.02 9.755 8.34 25.172z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M0 23.107h4.36l20.66-19.09 20.658 19.09H50L25.02 0z"
  })]
});